(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/cart.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/cart.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const selfserviceCart = svs.components.selfserviceCart;
const _svs$components$selfs = svs.components.selfserviceCart,
  constants = _svs$components$selfs.constants,
  logger = _svs$components$selfs.logger;
let cartInstance = null;
let cartRequestCount = 0;
const cartRequestRef = {};
let gameCallback = () => constants.GAMECALLBACK_NOGAME;
const getCartInstance = () => {
  if (cartInstance) {
    return cartInstance;
  }
  const createContext = selfserviceCart.createContext,
    setupListener = selfserviceCart.setupListener,
    fullCart = selfserviceCart.fullCart,
    actionFunctions = selfserviceCart.fns.actions;
  const _createContext = createContext(cartRequestRef),
    requests = _createContext.requests,
    sendRequest = _createContext.sendRequest,
    src = _createContext.src,
    store = _createContext.store,
    destroyContext = _createContext.destroy,
    showErrorDialog = _createContext.showErrorDialog;
  const actions = Object.keys(actionFunctions).reduce((acc, fn) => _objectSpread(_objectSpread({}, acc), {}, {
    [fn]: actionFunctions[fn]((data, callback, timeout) => {
      const requestId = ++cartRequestCount;
      callback = typeof callback === 'function' ? callback : () => {};
      timeout = timeout > 0 ? timeout : 30000;
      const internalCallback = err => {
        if (err) {
          showErrorDialog(() => {
            window.location.reload();
          });
        }
        callback(err);
      };
      cartRequestRef[requestId] = {
        callbackFn: internalCallback,
        timeoutId: setTimeout(() => {
          internalCallback(new Error('Callback timeout'));
        }, timeout)
      };
      try {
        sendRequest({
          data,
          requestId,
          name: fn,
          tenant: svs.core.data.tenant,
          context: constants.CONTEXT
        }, src);
      } catch (err) {
        logger.warn("Failed to execute sendRequest \"".concat(err.message, "\""));
        clearTimeout(cartRequestRef[requestId].timeoutId);
        internalCallback(err);
      }
    })
  }), {});
  const unlisten = setupListener(src, requests);
  const setGameCallback = fn => {
    if (typeof fn === 'function') {
      gameCallback = fn;
    }
  };
  const runCheckout = _ref => {
    let cartObj = _ref.cartObj,
      onSuccessCallback = _ref.onSuccessCallback,
      onErrorAbortCallback = _ref.onErrorAbortCallback,
      onFinishCallback = _ref.onFinishCallback;
    svs.components.selfservice.container.openCheckout({
      cartObj,
      onSuccessCallback,
      onErrorAbortCallback,
      onFinishCallback
    });
  };
  const checkout = _ref2 => {
    let cartObj = _ref2.cartObj,
      onSuccessCallback = _ref2.onSuccessCallback,
      onErrorAbortCallback = _ref2.onErrorAbortCallback,
      onFinishCallback = _ref2.onFinishCallback;
    const gameResult = gameCallback();
    if (gameResult === constants.GAMECALLBACK_HASINCOMPLETEGAME || gameResult === constants.GAMECALLBACK_HASCOMPLETEGAME) {
      const _constants$GAMECALLBA = _slicedToArray({
          [constants.GAMECALLBACK_HASCOMPLETEGAME]: ['Färdigt spel', 'Du har ett färdigt spel som du inte lagt i varukorgen.', 'Vill du fortsätta till kassan utan detta spel?'],
          [constants.GAMECALLBACK_HASINCOMPLETEGAME]: ['Påbörjat spel', 'Du har ett påbörjat spel.', 'Vill du fortsätta till kassan utan att färdigställa detta spel?']
        }[gameResult], 3),
        title = _constants$GAMECALLBA[0],
        textRow1 = _constants$GAMECALLBA[1],
        textRow2 = _constants$GAMECALLBA[2];
      const dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.NEUTRAL,
        title,
        icon: 'exclamation-sign',
        area: svs.components.dialog.area.POPUP,
        autoClose: 0,
        type: svs.components.dialog.type.DEFAULT,
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: textRow1,
          align: svs.components.dialog.message.align.CENTER
        }, {
          type: svs.components.dialog.message.TEXT,
          text: textRow2,
          align: svs.components.dialog.message.align.CENTER
        }],
        actions: [{
          title: 'Avbryt',
          callback() {
            svs.components.analytics.trackEvent({
              action: 'pop_up',
              category: 'färdigt spel',
              opt_label: 'cancel'
            });
            dialog.close();
          }
        }, {
          title: 'Fortsätt',
          showLoader: true,
          callback() {
            svs.components.analytics.trackEvent({
              action: 'pop_up',
              category: 'färdigt spel',
              opt_label: 'continue'
            });
            dialog.close();
            runCheckout({
              cartObj,
              onSuccessCallback,
              onErrorAbortCallback,
              onFinishCallback
            });
          }
        }]
      });
      svs.components.dialog.api.add(dialog);
    } else {
      runCheckout({
        cartObj,
        onSuccessCallback,
        onErrorAbortCallback,
        onFinishCallback
      });
    }
  };
  const destroy = () => {
    unlisten();
    destroyContext();
    cartInstance = null;
  };
  actions.getItems();
  cartInstance = {
    getStore: () => store,
    actions,
    destroy,
    setGameCallback,
    checkout
  };
  fullCart.initialize(cartInstance);
  return cartInstance;
};
setGlobal('svs.components.selfserviceCart.getCartInstance', getCartInstance);

 })(window);